import { PlusOutlined } from "@ant-design/icons";
import { Button, Space } from "antd";
import { useComputer } from "hook/base/computer/useComputerAction";
import React, { useState } from "react";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const MachineAdd = () => {
  // -------------------------- VAR -----------------------------
  const { handleOpen } = useComputer();
  // -------------------------- STATE ---------------------------
  // -------------------------- REDUX ---------------------------
  // -------------------------- FUNCTION ------------------------
  // -------------------------- EFFECT --------------------------
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  // -------------------------- MAIN ----------------------------
  return (
    <Space>
      <Button onClick={handleOpen} type="primary" icon={<PlusOutlined />}>
        Thêm Machine
      </Button>
    </Space>
  );
};
export default MachineAdd;
